var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twitter - Negative",
    clipPath: "url(#clip0_901_3663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.77508 10.8754C8.30227 10.8754 10.7791 7.12372 10.7791 3.8713C10.7791 3.76583 10.7768 3.65802 10.7721 3.55255C11.2539 3.2041 11.6697 2.77249 12 2.27802C11.5513 2.47767 11.0748 2.60806 10.587 2.66473C11.1006 2.35682 11.4853 1.8731 11.6695 1.30325C11.1863 1.58964 10.6578 1.79167 10.1067 1.90067C9.73542 1.50615 9.24449 1.24492 8.70984 1.15739C8.17519 1.06986 7.6266 1.16089 7.14887 1.41641C6.67115 1.67194 6.2909 2.07772 6.06692 2.57102C5.84295 3.06433 5.78771 3.61767 5.90977 4.14552C4.93125 4.09641 3.97397 3.84222 3.09999 3.39942C2.22601 2.95661 1.45485 2.33508 0.836484 1.57512C0.5222 2.11699 0.426028 2.75819 0.567515 3.36841C0.709002 3.97863 1.07753 4.51209 1.5982 4.86036C1.20731 4.84795 0.824988 4.74271 0.482813 4.55333V4.5838C0.482462 5.15244 0.679049 5.70366 1.03915 6.14375C1.39926 6.58384 1.90066 6.88565 2.45812 6.99786C2.09603 7.09693 1.71599 7.11137 1.34742 7.04005C1.50473 7.52908 1.81079 7.95681 2.22289 8.26353C2.63498 8.57025 3.13256 8.74066 3.64617 8.75098C2.77421 9.43592 1.69709 9.80743 0.588281 9.80567C0.391644 9.80537 0.1952 9.79332 0 9.76958C1.12643 10.4922 2.43677 10.8761 3.77508 10.8754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_901_3663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterwhite);
export default __webpack_public_path__ + "static/media/twitterwhite.97f4ab5a61ec8d3d60173fb6fbbad417.svg";
export { ForwardRef as ReactComponent };